import React from 'react';
import { Icon } from './Icon.js';
export const IconFeather2 = ({ ...props }) => {
    return (React.createElement(Icon, { size: "24px", ...props },
        React.createElement("path", { d: "M12 12H18.5", stroke: "currentColor", strokeWidth: "2", "data-color": "color-2", fill: "none" }),
        React.createElement("path", { d: "M18 2L22 6L15 18L6 18L6 9L18 2Z", stroke: "currentColor", strokeWidth: "2", "data-color": "color-2", fill: "none" }),
        React.createElement("path", { d: "M16 8L3 21", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "square", strokeLinejoin: "round", fill: "none" })));
};
//# sourceMappingURL=IconFeather2.js.map